module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_innlandet_pos.e9103bf6.pdf";